<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Combined Stock Report</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" xs="12" md="8">
            <v-row>
              <v-col cols="12" xs="12" md="8">
                 <v-autocomplete :filter="customFilter" style="width: 500px" autocomplete="off" v-model="select"
              :isloading="isLoading" :items="products" :search-input.sync="searchProducts"
              @change="setOrderItem(select)" :item-text="smsRef == 'pharmacy' ? 'full_name' : 'Name'" item-value="id"
              cache-items  flat hide-no-data hide-details label="Search Product" outlined dense>
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{ data.item.Name
                  }}</v-list-item-title>

                </v-list-item-content>
              </template>
            </v-autocomplete>
              </v-col>

              <v-col cols="12" xs="12" md="4">
                <v-btn
                  color="accent"
                  :loading="loader"
                  @click="queryData"
                >Query Data</v-btn>
              </v-col>

              <v-col cols="12" style="margin-top: -20px">
                <span
                  style="color: blue; font-size: 16px; font-weight: bold"
                >Total Qty: {{totalStock}}</span>
                <br />

                <v-data-table
                  :mobile-breakpoint="0"
                  :loading="loader"
                  loading-text="Loading Data......"
                  :headers="headers"
                  :items="combinedStock"
                  :search="search"
                >
                </v-data-table>
                <!-- end -->
              </v-col>
            </v-row>
          </v-col>
        </v-row>

      </v-card-text>
      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    role() {
      return localStorage.getItem("userRole");
    },
  },
  data() {
    return {
      search: null,
      productsDialog: false,
      storeDialog: false,
      selectedStore: null,
      totalStock: 0,
      pageItems: 500,
      record: {},
      QueryOption: "C",
      select: "",
      loader: false,
      ProductID: null,
      TotalStock: null,
      storeProducts: [],
      combinedStock: [],
      products: [],
      brands: [],
      categories: [],
      editItem: {},
      damagedItem: {},
      transferItem: {},
      generalSettings: {},
      store: null,
      queryStore: null,
      stores: [],
      users: [],
      date: null,
      dialog: false,
      damageDialog: false,
      transferDialog: false,
      searchProducts: null,
      headers: [
        { text: "Store/Shop", value: "store" },
        { text: "Available Qty", value: "availableStock" }
      ],
      productHeaders: [
        { text: "Name", value: "Name" },
        { text: "Qty", value: "totalQty" },
      ],
      fields: {
        Product: "product.Name",
        Quantity: "AvailableQty",
      },
      combinedFields: {
        Product: "Name",
        Quantity: "totalQty",
      },
      storeHeaders: [
        { text: "Name", value: "product.Name" },
        { text: "Qty", value: "AvailableQty" },
      ],
      inventory: [],
    };
  },
  watch: {
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
  },
  methods: {
      customFilter(item, queryText, itemText) {
      const words = queryText.toLowerCase().split(/\s+/)
      const text = itemText.toLowerCase()
      return words.every(word => text.includes(word))
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      var customerId = 0;

      if (this.record.CardCode) {
        customerId = this.record.CardCode;
      }

      const data = {
        SearchText: searchText,
        CustomerId: customerId
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null) {
              self.products = res.ResponseData;
            }
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    queryData() {

      if(this.select == undefined || this.select == null || this.select == ""){
        this.$refs.snackbar.show("Please select a product ! ", "red");
        return;
      }

      const data = {
        ProductId: parseInt(this.select),
        SubscriberId: parseInt(localStorage.getItem('subscriber_id'))
      };

      const url = "/combined-stock";

      this.loader = true;

      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            this.combinedStock = res.ResponseData.stockData;
            this.totalStock = res.ResponseData.totalStock;
            this.loader = false;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            this.loader = false;
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
          this.loader = false;
        });
    },
  },
  created() {

  },
};
</script>

<style lang="scss" scoped>
</style>